import styled from "styled-components";

export const LiveStreamingSoundButtonDefaultBox = styled.div`
    padding: 0.25rem;
    background: ${({theme}) => theme.colors.bodyBackground.toString()};
    border-radius: 50%;
`;
